/**
 * Ravencoin Asset Trading Section
 * Just renders RavencoinOrderBook directly without extra wrapper
 */

import RavencoinOrderBook from './RavencoinOrderBook';

export default function RavencoinTrading() {
  return <RavencoinOrderBook />;
}

